import React, { useEffect, Fragment } from "react";
import { withRouter } from "react-router-dom";
function ScrollToTop(_ref) {
  let {
    history,
    children
  } = _ref;
  useEffect(() => {
    const unlisten = history.listen(() => {
      window.scrollTo({
        top: 0,
        left: 0,
        behavior: "auto"
      });
    });
    return () => {
      unlisten();
    };
  }, []);
  return /*#__PURE__*/React.createElement(Fragment, null, children);
}
export function ScrollToTopFunction() {
  window.scrollTo({
    top: 0,
    left: 0,
    behavior: "auto"
  });
}
export default withRouter(ScrollToTop);